import { useState, useEffect } from 'react';
import { Modal, Stack, Form, Button, Tabs, Tab, Row, Col } from "react-bootstrap";
import editarProducto from "../functions/editarProducto";
import { logBusinessAction } from "../services/AuditService";
import firebaseApp from "../firebase/credenciales";
import { createUserWithEmailAndPassword, getAuth } from "firebase/auth";
import { initializeApp, getApps } from "firebase/app";
import { firebaseWebConfig } from "../config/firebaseEnv";
import { collection, doc, getDoc, getDocs, getFirestore } from "firebase/firestore";
import Swal from 'sweetalert2';
import { assignUserMembership } from "../services/groupAssignmentService";
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

// Configuración de Firebase (Debe coincidir con la de credenciales.js)
const firebaseConfig = firebaseWebConfig;

// Función para obtener o crear una instancia secundaria de Firebase
// Esto evita que createUserWithEmailAndPassword cierre la sesión del admin
const getSecondaryAuth = () => {
  const appName = "secondaryApp";
  let secondaryApp;

  const apps = getApps();
  const existingApp = apps.find(app => app.name === appName);

  if (existingApp) {
    secondaryApp = existingApp;
  } else {
    secondaryApp = initializeApp(firebaseConfig, appName);
  }

  return getAuth(secondaryApp);
};
function ModalEditar({
  isModalEditar,
  setIsModalEditar,
  actualizarEstadoProductos,
  productoEditar,
  setProductoEditar,
  usuario,
  cecos = [],
  contratos = [],
}) {
  const unique = (arr) => Array.from(new Set((arr || []).filter(Boolean).map((v) => String(v))));

  const [gruposEmpresa, setGruposEmpresa] = useState([]);
  const [sedesEmpresa, setSedesEmpresa] = useState([]);
  const [grupoSeleccionadoId, setGrupoSeleccionadoId] = useState("");
  const [grupoInicialId, setGrupoInicialId] = useState("");
  const [sedeIdsSeleccionadas, setSedeIdsSeleccionadas] = useState([]);
  const [sedeIdsIniciales, setSedeIdsIniciales] = useState([]);

  const sedesDelGrupoSeleccionado = sedesEmpresa.filter((s) =>
    (gruposEmpresa.find((g) => String(g.id) === String(grupoSeleccionadoId))?.sedes || []).includes(String(s.id))
  );

  const sincronizarCambioGrupoUsuario = async (dni) => {
    const previousGroupId = String(grupoInicialId || "");
    const nextGroupId = String(grupoSeleccionadoId || "");
    const oldGroup = gruposEmpresa.find((g) => String(g.id) === previousGroupId) || null;
    const newGroup = gruposEmpresa.find((g) => String(g.id) === nextGroupId) || null;
    await assignUserMembership({
      rucEmpresa: usuario.ruc,
      dni,
      previousGroup: oldGroup,
      nextGroup: newGroup,
      previousSedeIds: unique(sedeIdsIniciales),
      nextSedeIds: unique(sedeIdsSeleccionadas),
      sedesData: sedesEmpresa,
      companyName: productoEstado?.empresa || "Mi Empresa",
    });

    setGrupoInicialId(nextGroupId);
    setSedeIdsIniciales(unique(sedeIdsSeleccionadas));
  };

  async function editarProductoModal() {
    setLoading(true); // Mostrar loading al inicio

    try {
      let rol;
      if (usuario.dni === document.getElementById("dni").value) {
        rol = usuario.rol
      } else {
        rol = 'user'
      }

    //obtener infor del formulario  
    const activo = isActivo
    const id = productoEditar.id;
    const rucEmpresa = usuario.ruc;
    const dni = document.getElementById("dni").value.trim().toUpperCase();
    const legajo = document.getElementById("legajo").value.trim();
    const legajo2 = document.getElementById("legajo2") ? document.getElementById("legajo2").value.trim() : "";
    const name = document.getElementById("name").value.trim().toUpperCase();
    const apellidos = document.getElementById("apellidos").value.trim().toUpperCase();
    const email = document.getElementById("correo").value.trim().toLowerCase();
    const phone = document.getElementById("phone").value.trim();
    const direccion = document.getElementById("direccion").value.trim().toUpperCase();
    const vacaciones = document.getElementById("vacaciones").value.trim();
    const cargo = document.getElementById("cargo").value.trim().toUpperCase();
    const contrato = document.getElementById("contrato").value.trim().toUpperCase();
    const recursosHumanos = document.getElementById("recursosHumanos").value.trim().toLowerCase();
    const supervisor = document.getElementById("supervisor").value.trim().toLowerCase();

    const permisos = productoEditar?.permisos || {};

    const cecoId = productoEstado?.cecoId || "";
    const cecoNombre = cecos.find(c => c.id === cecoId)?.nombre || "";

    const vencimientoContrato = productoEstado?.vencimientoContrato || "";
    const vencimientoEMO = productoEstado?.vencimientoEMO || "";

    // enviar informacion a firebase
    const infoProducto = {
      activo, cargo, contrato, recursosHumanos, supervisor, rucEmpresa,
      rol, id, dni, legajo, legajo2, name, apellidos, email, phone, direccion, vacaciones,
      cecoId, cecoNombre, permisos, vencimientoContrato, vencimientoEMO
    };

    // Esperar a que se complete la edición
    await editarProducto(infoProducto, usuario.email, "users", id);
    await sincronizarCambioGrupoUsuario(dni);

    // Calcular cambios
    const cambios = {};
    Object.keys(infoProducto).forEach(key => {
      if (key === 'permisos') {
        const permisosAntiguos = JSON.stringify(productoEditar.permisos || {});
        const permisosNuevos = JSON.stringify(infoProducto.permisos || {});
        if (permisosAntiguos !== permisosNuevos) {
          cambios.permisos = { modificado: true };
        }
      } else if (infoProducto[key] !== productoEditar[key]) {
        cambios[key] = {
          anterior: productoEditar[key] || "",
          nuevo: infoProducto[key] || ""
        };
      }
    });

    // Registrar auditoría Opción B
    await logBusinessAction(
      "EDICION_USUARIO",
      "GestionUsuarios",
      { 
        dniEditado: dni, 
        emailEditado: email,
        cambiosRealizados: cambios 
      },
      usuario
    );


      // Esperar a que se actualice la lista de usuarios
      await actualizarEstadoProductos("users", rucEmpresa);

      // cerrar modal
      setProductoEditar(null);
      setIsModalEditar(false);
    } catch (error) {
      console.error("Error al editar usuario:", error);
      Swal.fire("Error", "No se pudo guardar la información", "error");
    } finally {
      setLoading(false); // Ocultar loading
    }
  }

  const [loading, setLoading] = useState(false);
  const [productoEstado, setProductoEstado] = useState({
    ...productoEditar,
  });
  const [isActivo, setIsActivo] = useState(productoEstado?.activo);
  // Inicializar basado en si ya tiene UID de Firebase en Firestore
  const [isUsuarioExistente, setIsUsuarioExistente] = useState(!!productoEditar?.firebaseUid);

  async function crearUsuario(email, dni) {
    // Limpieza básica de datos
    const emailLimpio = String(email || "").trim().toLowerCase();
    const dniLimpio = String(dni || "").trim();

    if (!emailLimpio || !dniLimpio) return;

    try {
      const secondaryAuth = getSecondaryAuth();
      await createUserWithEmailAndPassword(secondaryAuth, emailLimpio, dniLimpio);
      Swal.fire('Usuario creado', 'El usuario ha sido habilitado en el sistema de autenticación exitosamente.', 'success');
      setIsUsuarioExistente(true);
    } catch (error) {
      if (error.code === 'auth/email-already-in-use') {
        setIsUsuarioExistente(true);
        // No mostramos error porque es normal que ya exista al editar
      } else {
        console.error("Error al crear usuario en Auth:", error);
        let mensajeError = 'Ha ocurrido un error al crear la cuenta de acceso.';
        
        if (error.code === 'auth/weak-password') {
          mensajeError = 'La contraseña (DNI) es demasiado débil. Debe tener al menos 6 caracteres.';
        } else if (error.code === 'auth/invalid-email') {
          mensajeError = 'El formato del correo electrónico es inválido.';
        } else if (error.message) {
          mensajeError = `Error: ${error.message}`;
        }

        Swal.fire('Error de Acceso', mensajeError, 'error');
      }
    }
  }

  useEffect(() => {
    setProductoEstado({ ...productoEditar });
    setIsActivo(productoEditar?.activo);
    setIsUsuarioExistente(!!productoEditar?.firebaseUid);
  }, [productoEditar]);

  useEffect(() => {
    // Ya no creamos el usuario automáticamente al abrir para evitar rate limits
    // El administrador puede hacerlo manualmente si lo desea
    if (productoEditar?.firebaseUid) {
      setIsUsuarioExistente(true);
    }
  }, [productoEditar]);

  useEffect(() => {
    const cargarDatosGrupo = async () => {
      if (!isModalEditar || !usuario?.ruc || !productoEditar?.dni) return;
      try {
        const [groupsSnap, sedesSnap, membershipSnap] = await Promise.all([
          getDocs(collection(db, `grupos/${usuario.ruc}/grupos`)),
          getDocs(collection(db, `company_cordenadas/${usuario.ruc}/sedes`)),
          getDoc(doc(db, `grupos/${usuario.ruc}/memberships`, String(productoEditar.dni))),
        ]);

        const groupsData = groupsSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
        const sedesData = sedesSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
        const groupId = membershipSnap.exists() ? String(membershipSnap.data()?.groupId || "") : "";
        const sedeIds = membershipSnap.exists() ? unique(membershipSnap.data()?.sedeIds || []) : [];
        const groupForDefault = groupsData.find((g) => String(g.id) === groupId);
        const sedeIdsDefault = sedeIds.length > 0 ? sedeIds : unique(groupForDefault?.sedes || []);

        setGruposEmpresa(groupsData);
        setSedesEmpresa(sedesData);
        setGrupoInicialId(groupId);
        setGrupoSeleccionadoId(groupId);
        setSedeIdsIniciales(sedeIdsDefault);
        setSedeIdsSeleccionadas(sedeIdsDefault);
      } catch (error) {
        console.error("Error cargando grupos/sedes para edición de usuario:", error);
      }
    };

    cargarDatosGrupo();
  }, [isModalEditar, usuario?.ruc, productoEditar?.dni]);

  useEffect(() => {
    const group = gruposEmpresa.find((g) => String(g.id) === String(grupoSeleccionadoId));
    if (!group) {
      setSedeIdsSeleccionadas([]);
      return;
    }
    const permitidas = unique(group.sedes || []);
    setSedeIdsSeleccionadas((prev) => {
      const actuales = prev.filter((id) => permitidas.includes(String(id)));
      return actuales;
    });
  }, [grupoSeleccionadoId, gruposEmpresa]);

  return (
    <Modal
      show={isModalEditar}
      onHide={() => {
        setIsModalEditar(false);
        setProductoEditar(null);
      }}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Editar Usuario</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Tabs defaultActiveKey="datos" id="edit-user-tabs" className="mb-3">
            <Tab eventKey="datos" title="Datos Personales">
              <Stack gap={2}>
                {isActivo ?
                  "" :
                  <Form.Check
                    type="switch"
                    id="activo"
                    label="Activar Usuario"
                    className="mb-1"
                    onChange={() =>
                      setIsActivo(true)}
                  />
                }
                <div className="d-flex align-items-center gap-2 mb-3 p-2 bg-light rounded border">
                  <Form.Check
                    type="switch"
                    id="verificarLogin"
                    label={isUsuarioExistente ? "Acceso APP Habilitado" : "Acceso APP No Detectado"}
                    checked={isUsuarioExistente}
                    onChange={() => {
                      if (!isUsuarioExistente) {
                        crearUsuario(productoEstado.email, productoEstado.dni);
                      }
                    }}
                    style={{ cursor: isUsuarioExistente ? 'default' : 'pointer' }}
                  />
                  {!isUsuarioExistente && (
                    <Button 
                      variant="link" 
                      size="sm" 
                      className="p-0 text-decoration-none"
                      onClick={() => crearUsuario(productoEstado.email, productoEstado.dni)}
                    >
                      (Habilitar ahora)
                    </Button>
                  )}
                </div>
                <Form.Group>
                  <Form.Label className="small fw-bold">DNI</Form.Label>
                  <Form.Control
                    id="dni"
                    placeholder="DNI"
                    type="number"
                    value={productoEstado?.dni}
                    disabled
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="small fw-bold">LEGAJO</Form.Label>
                  <Form.Control
                    id="legajo"
                    placeholder="LEGAJO"
                    type="text"
                    value={productoEstado?.legajo}
                    onChange={(e) =>
                      setProductoEstado({
                        ...productoEstado,
                        legajo: e.target.value,
                      })
                    }
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="small fw-bold">LEGAJO 2 (OPCIONAL)</Form.Label>
                  <Form.Control
                    id="legajo2"
                    placeholder="LEGAJO 2"
                    type="text"
                    value={productoEstado?.legajo2 || ""}
                    onChange={(e) =>
                      setProductoEstado({
                        ...productoEstado,
                        legajo2: e.target.value,
                      })
                    }
                  />
                </Form.Group>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label className="small fw-bold">NOMBRES</Form.Label>
                      <Form.Control
                        id="name"
                        placeholder="NOMBRES"
                        type="text"
                        value={productoEstado?.name}
                        onChange={(e) =>
                          setProductoEstado({
                            ...productoEstado,
                            name: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label className="small fw-bold">APELLIDOS</Form.Label>
                      <Form.Control
                        id="apellidos"
                        placeholder="APELLIDOS"
                        type="text"
                        value={productoEstado?.apellidos}
                        onChange={(e) =>
                          setProductoEstado({
                            ...productoEstado,
                            apellidos: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group>
                  <Form.Label className="small fw-bold">EMAIL</Form.Label>
                  <Form.Control
                    id="correo"
                    placeholder="EMAIL"
                    type="email"
                    value={productoEstado?.email}
                    onChange={(e) =>
                      setProductoEstado({
                        ...productoEstado,
                        email: e.target.value,
                      })
                    }
                  />
                </Form.Group>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label className="small fw-bold">N° CELULAR</Form.Label>
                      <Form.Control
                        id="phone"
                        placeholder="N° CELULAR"
                        type="number"
                        value={productoEstado?.phone}
                        onChange={(e) =>
                          setProductoEstado({
                            ...productoEstado,
                            phone: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label className="small fw-bold">DIRECCIÓN</Form.Label>
                      <Form.Control
                        id="direccion"
                        placeholder="DIRECCIÓN"
                        type="text"
                        value={productoEstado?.direccion}
                        onChange={(e) =>
                          setProductoEstado({
                            ...productoEstado,
                            direccion: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Stack>
            </Tab>

            <Tab eventKey="empresa" title="Datos Laborales">
              <Stack gap={2}>
                <Form.Group>
                  <Form.Label className="small fw-bold">CARGO</Form.Label>
                  <Form.Control
                    id="cargo"
                    placeholder="CARGO"
                    type="text"
                    value={productoEstado?.cargo}
                    onChange={(e) =>
                      setProductoEstado({
                        ...productoEstado,
                        cargo: e.target.value,
                      })
                    }
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="small fw-bold">CENTRO DE COSTO</Form.Label>
                  <Form.Select
                    id="cecoId"
                    value={productoEstado?.cecoId || ""}
                    onChange={(e) =>
                      setProductoEstado({
                        ...productoEstado,
                        cecoId: e.target.value,
                      })
                    }
                  >
                    <option value="">-- SELECCIONAR CECO --</option>
                    {cecos.map((ceco) => (
                      <option key={ceco.id} value={ceco.id}>
                        {ceco.nombre}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group>
                  <Form.Label className="small fw-bold">GRUPO DE USUARIO</Form.Label>
                  <Form.Select
                    id="grupoUsuario"
                    value={grupoSeleccionadoId}
                    onChange={(e) => setGrupoSeleccionadoId(e.target.value)}
                  >
                    <option value="">-- SIN GRUPO --</option>
                    {gruposEmpresa.map((grupo) => (
                      <option key={grupo.id} value={grupo.id}>
                        {grupo.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                {grupoSeleccionadoId && (
                  <Form.Group>
                    <Form.Label className="small fw-bold">SEDES/COORDENADAS ASIGNADAS</Form.Label>
                    <div className="border rounded p-2" style={{ maxHeight: "150px", overflowY: "auto" }}>
                      {sedesDelGrupoSeleccionado.length > 0 ? (
                        sedesDelGrupoSeleccionado.map((sede) => (
                          <Form.Check
                            key={sede.id}
                            type="checkbox"
                            id={`sede-grupo-${sede.id}`}
                            label={`${sede.nombre} (${sede.latitud || "-"}, ${sede.longitud || "-"})`}
                            checked={sedeIdsSeleccionadas.includes(String(sede.id))}
                            onChange={(e) => {
                              const sedeId = String(sede.id);
                              if (e.target.checked) {
                                setSedeIdsSeleccionadas((prev) => unique([...prev, sedeId]));
                              } else {
                                setSedeIdsSeleccionadas((prev) => prev.filter((id) => String(id) !== sedeId));
                              }
                            }}
                          />
                        ))
                      ) : (
                        <small className="text-muted">El grupo no tiene sedes configuradas.</small>
                      )}
                    </div>
                    <Form.Text className="text-muted">
                      Selecciona 1 o más sedes para este trabajador dentro del grupo.
                    </Form.Text>
                    {sedeIdsSeleccionadas.length === 0 && (
                      <div className="mt-2 small text-warning">
                        Aviso: este usuario quedará en el grupo sin sedes/coordenadas geográficas asignadas.
                      </div>
                    )}
                  </Form.Group>
                )}
                <Form.Group>
                  <Form.Label className="small fw-bold">TIPO DE CONTRATO</Form.Label>
                  <Form.Select
                    id="contrato"
                    value={String(productoEstado?.contrato || "").toUpperCase()}
                    onChange={(e) =>
                      setProductoEstado({
                        ...productoEstado,
                        contrato: e.target.value,
                      })
                    }
                  >
                    <option value="">-- SELECCIONAR CONTRATO --</option>
                    {Array.from(
                      new Set(
                        [
                          ...contratos,
                          String(productoEstado?.contrato || "").trim().toUpperCase(),
                        ].filter(Boolean)
                      )
                    ).map((contratoOption) => (
                      <option key={contratoOption} value={contratoOption}>
                        {contratoOption}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="small fw-bold text-danger">FIN DE CONTRATO</Form.Label>
                      <Form.Control
                        type="date"
                        value={productoEstado?.vencimientoContrato || ""}
                        onChange={(e) =>
                          setProductoEstado({
                            ...productoEstado,
                            vencimientoContrato: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="small fw-bold text-primary">VENCIMIENTO EMO</Form.Label>
                      <Form.Control
                        type="date"
                        value={productoEstado?.vencimientoEMO || ""}
                        onChange={(e) =>
                          setProductoEstado({
                            ...productoEstado,
                            vencimientoEMO: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group>
                  <Form.Label className="small fw-bold">VACACIONES ACUMULADAS</Form.Label>
                  <Form.Control
                    id="vacaciones"
                    placeholder="VACACIONES"
                    type="number"
                    value={productoEstado?.vacaciones}
                    onChange={(e) =>
                      setProductoEstado({
                        ...productoEstado,
                        vacaciones: e.target.value,
                      })
                    }
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="small fw-bold">CORREO RRHH</Form.Label>
                  <Form.Control
                    id="recursosHumanos"
                    placeholder="CORREO RRHH"
                    type="text"
                    value={productoEstado?.recursosHumanos}
                    onChange={(e) =>
                      setProductoEstado({
                        ...productoEstado,
                        recursosHumanos: e.target.value,
                      })
                    }
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="small fw-bold">CORREO SUPERVISOR</Form.Label>
                  <Form.Control
                    id="supervisor"
                    placeholder="CORREO SUPERVISOR"
                    type="text"
                    value={productoEstado?.supervisor}
                    onChange={(e) =>
                      setProductoEstado({
                        ...productoEstado,
                        supervisor: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Stack>
            </Tab>

          </Tabs>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          disabled={loading}
          onClick={() => {
            setIsModalEditar(false);
            setProductoEditar(null);
          }}
        >
          Cancelar
        </Button>
        <Button variant="primary" onClick={editarProductoModal} disabled={loading}>
          {loading ? "Guardando..." : "Guardar Cambios"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalEditar;
